import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { Group, Button, StyledIcon } from './styles';

const ButtonsGroup = ({ buttons, onClick, selected }) => {
  const onSelect = value => {
    onClick(value);
  };

  const renderFilterButton = button => {
    return (
      <Button
        key={button.value}
        onClick={() => onSelect(button.value)}
        data-checked={selected === button.value}
      >
        {selected === button.value && <StyledIcon name="filterArrow" />}
        {button?.name ? <FormattedMessage id={button.name} /> : button?.label}
      </Button>
    );
  };

  return <Group>{buttons?.map(button => renderFilterButton(button))}</Group>;
};

ButtonsGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.string,
};

ButtonsGroup.defaultProps = {
  selected: null,
};

export default ButtonsGroup;
